import i18n from '@/i18n.js'

const eventsConfig = {
  VF: {
    abbr: 'VF',
    text: i18n.t('events.vf'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  AF: {
    abbr: 'AF',
    text: i18n.t('events.af'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  SinusArrest: {
    abbr: 'SA',
    text: i18n.t('events.sinusArrest'),
    duration: true,
    decimalNumbers: 2,
    color: 'danger'
  },
  VExtrasystoleBeat: {
    abbr: 'VEB',
    text: i18n.t('events.vExtrasystoleBeat'),
    duration: false,
    decimalNumbers: 0,
    color: 'secondary'
  },
  SVExtrasystoleBeat: {
    abbr: 'SVEB',
    text: i18n.t('events.svExtrasystoleBeat'),
    duration: false,
    decimalNumbers: 0,
    color: 'secondary'
  },
  FrequentExtrasystole: {
    abbr: 'FEB',
    text: i18n.t('events.frequentExtrasystole'),
    duration: false,
    decimalNumbers: 0,
    color: 'danger'
  },
  FrequentVExtrasystole: {
    abbr: 'FVEB',
    text: i18n.t('events.frequentVExtrasystole'),
    duration: false,
    decimalNumbers: 0,
    color: 'danger'
  },
  FrequentSVExtrasystole: {
    abbr: 'FSVEB',
    text: i18n.t('events.frequentSVExtrasystole'),
    duration: false,
    decimalNumbers: 0,
    color: 'danger'
  },
  VTach: {
    abbr: 'VT',
    text: i18n.t('events.vTach'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  SVTach: {
    abbr: 'SVT',
    text: i18n.t('events.sVTach'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  SABlock: {
    abbr: 'SAB',
    text: i18n.t('events.sABlock'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  AVBlock: {
    abbr: 'AVB',
    text: i18n.t('events.avBlock'),
    duration: false,
    decimalNumbers: 0,
    color: 'danger'
  },
  AVBlockI: {
    abbr: 'AVB-I',
    text: i18n.t('events.avBlockI'),
    duration: true,
    decimalNumbers: 0,
    color: 'warning'
  },
  LBBB: {
    abbr: 'LBBB',
    text: i18n.t('events.lBBB'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  Brad: {
    abbr: 'B',
    text: i18n.t('events.brad'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  LowHR: {
    abbr: 'HR<sub>low</sub>',
    text: i18n.t('events.lowHR'),
    duration: true,
    decimalNumbers: 0,
    notAlarm: true,
    color: 'warning'
  },
  STDepression: {
    abbr: 'STD',
    text: i18n.t('events.stDepression'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  STElevation: {
    abbr: 'STE',
    text: i18n.t('events.stElevation'),
    duration: true,
    decimalNumbers: 0,
    color: 'danger'
  },
  STDepression_Low: {
    abbr: 'STD<sub><1</sub>',
    text: i18n.t('events.stDepression_Low'),
    duration: true,
    decimalNumbers: 0,
    color: 'warning'
  },
  STElevation_Low: {
    abbr: 'STE<sub><1</sub>',
    text: i18n.t('events.stElevation_Low'),
    duration: true,
    decimalNumbers: 0,
    color: 'warning'
  },
  PoseHorizontal: {
    abbr: 'H',
    text: i18n.t('events.poseHorizontal'),
    duration: false,
    decimalNumbers: 0,
    color: 'secondary'
  },
  PoseVertical: {
    abbr: 'V',
    text: i18n.t('events.poseVertical'),
    duration: false,
    decimalNumbers: 0,
    color: 'secondary'
  },
  UserEvent: {
    abbr: 'User',
    text: i18n.t('events.userEvent'),
    duration: false,
    decimalNumbers: 0,
    color: 'primary'
  },
  eventSpO2: {
    abbr: 'SpO2',
    text: 'SpO2',
    duration: false,
    decimalNumbers: 0,
    color: 'primary',
    value: true,
    unit: '%'
  },
  ElectrodeBreak: {
    abbr: 'EB',
    text: i18n.t('events.electrodeBreak'),
    duration: false,
    decimalNumbers: 0,
    color: 'primary',
    value: true
  },
  eventBP: {
    abbr: 'BP',
    text: i18n.t('events.eventBP'),
    duration: false,
    decimalNumbers: 0,
    color: 'primary',
    value: true,
    unit: ` ${i18n.t('unit.mmHg')}`
  },
  eventBodyTemp: {
    abbr: 'BT',
    text: i18n.t('events.eventBodyTemp'),
    duration: false,
    decimalNumbers: 0,
    color: 'primary',
    value: true,
    unit: '°C'
  },
  eventText: {
    abbr: 'Txt',
    text: i18n.t('events.eventText'),
    duration: false,
    decimalNumbers: 0,
    color: 'primary',
    value: true
  },
  break: {
    abbr: 'BR',
    text: i18n.t('events.break'),
    duration: false,
    decimalNumbers: 0,
    color: 'warning',
    value: true
  },
  reconnected: {
    abbr: 'RC',
    text: i18n.t('events.reconnected'),
    duration: false,
    decimalNumbers: 0,
    color: 'warning',
    value: true
  }
  // LostSamples: {
  //   abbr: 'LS',
  //   text: 'Разрыв записи ЭКГ',
  //   duration: false,
  //   decimalNumbers: 0,
  //   color: 'secondary'
  // }
}

const notAlarm = ['VExtrasystoleBeat', 'SVExtrasystoleBeat', 'ElectrodeBreak']
const notShow = ['LostSamples', 'eventStartWalking', 'eventStopWalking']
const showInChat = ['eventText', 'eventBodyTemp', 'eventBP', 'eventSpO2']

export { eventsConfig, notAlarm, notShow, showInChat }
